import { Link, SxProps, Theme, TypographyOwnProps } from '@mui/material';

interface IProps {
  href?: string;
  children?: React.ReactNode;
  target?: React.HTMLAttributeAnchorTarget;
  color?: TypographyOwnProps['color'];
  underline?: 'none' | 'hover' | 'always';
  variant?: TypographyOwnProps['variant'];
  sx?: SxProps<Theme>;
}
export function FSLink({
  href,
  children,
  target,
  color = 'primary',
  underline,
  variant,
  sx,
}: IProps) {
  return (
    <Link
      href={href}
      target={target}
      color={color}
      variant={variant}
      underline={underline}
      sx={sx}
    >
      {children}
    </Link>
  );
}
